export default {
    fields:[
        {
            key: "id",
            label:"#",
            sorter: false,
            _filter: false,
            fixed: true,
        },
        {
            key: "userId",
            label:"user_id",
            sorter: false,
            _filter: false,
            fixed: true,
            _classes: ["d-none"] 
        },
        {
            key: "userName",
            label:"user_name",
            sorter: false,
            _filter: false,
            fixed: true,
        },
        {
            key: "ip",
            label:"ip",
            sorter: false,
            _filter: true,
        },
        {
            key: "host",
            label:"host",
            sorter: false,
            _filter: true,
        },
        {
            key: "path",
            label:"action",
            sorter: false,
            _filter: true,
        },
        {
            key: "date",
            label:"date",
            sorter: false,
            _filter: false,
        }
        
    ],
    allFields:[],
    items:[],
    order:'desc',
    rows:10,
    page: 0,
    lastEvaluatedKey:null,
    totalPages:0,
    loading:false,
}